import React from "react";
import "./SectionThreeMobile.css";
function SectionThreeMobile() {
  return (
    <div className="section-three-mobile">
      <div className="container-fluid section-three-mobile-container py-4">
        <div className="row px-0 mx-0">
          <div className="col-12 text-center">
            <span className="section-three-mobile-heading">
              Real Estate Made <span className="bold-content">Real Easy.</span>
            </span>
          </div>
          <div className="col-12 mt-2">
            <h2 className="section-three-mobile-step">Step 1</h2>
            <p className="section-three-mobile-text">
              Search for homes in the area you wish to buy. You can search by
              address or better yet an entire zip code to see homes for sale.
              When you find a home you like, simply click on{" "}
              <span className="bold-content">Make and Offer</span> or{" "}
              <span className="bold-content">Take a Tour Button.</span>
            </p>
          </div>
          <div className="col-12">
            <h2 className="section-three-mobile-step">Step 2</h2>
            <p className="section-three-mobile-text">
              Create your profile, and verify your financing
            </p>
          </div>
          <div className="col-12">
            <h2 className="section-three-mobile-step">Step 3</h2>
            <p className="section-three-mobile-text">
              You will then be connected with your personal{" "}
              <span className="bold-content">Transaction Coordinator</span> who
              can easily assist you with all stages of the buying process,
              including writing an offer.
            </p>
          </div>
          <div className="col-12">
            <h2 className="section-three-mobile-step">Step 4</h2>
            <p className="section-three-mobile-text">
              If not ready to make an offer, you can be connected to a{" "}
              <span className="bold-content">Showing Agent</span> who can show
              you as many properties as you like.
            </p>
          </div>
          <div className="col-12">
            <h2 className="section-three-mobile-step">Step 5</h2>
            <p className="section-three-mobile-text">
              A list of Top Rated{" "}
              <span className="bold-content">Service Providers</span> in your
              chosen area will be provided to you. Everything from Home
              Inspection, Home Owner Insurance to Gardening is available.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionThreeMobile;
